import React from 'react';
import { DynamicFormTypes } from '../DynamicFormTypes';

export const FormikStep = ({
  children,
  stepperFormLabel,
}: DynamicFormTypes.FormikStepProps) => {
  return (
    <>
      {stepperFormLabel && (
        <p
          className="stepperFormLabel"
          dangerouslySetInnerHTML={{ __html: stepperFormLabel }}
        />
      )}
      {children}
    </>
  );
};
